import { render, staticRenderFns } from "./ListProductCardWAdd.vue?vue&type=template&id=509d028c"
import script from "./ListProductCardWAdd.vue?vue&type=script&lang=js"
export * from "./ListProductCardWAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports